import axios, { AxiosRequestConfig } from "axios";
import { trace as startTrace } from "firebase/performance";
import { perf } from "../../utils/firebase";

export const setHairAnalysis = async (formData: FormData | null) => {
  if (!formData) return undefined;
  const url = `${process.env.REACT_APP_GCP_BASE_URL}/glamlab/api/hair/v1/analyze`;
  const axiosConfig: AxiosRequestConfig = {
    url: url,
    method: "POST",
    params: null,
    data: formData,
    headers: {
      "x-api-key": process.env.REACT_APP_GCP_API_KEY,
      "Content-Type": "multipart/form-data",
    },
  };

  const trace = startTrace(perf, `Api call: ${url}`);
  trace.start();

  try {
    const response = await axios(axiosConfig);
    return response;
  } catch (error) {
    throw error;
  } finally {
    trace.stop();
  }
};

export const createQuiz = async (quiz: any) => {
  const url = `${process.env.REACT_APP_GCP_BASE_URL}/glamlab/api/hair/v1/quiz`;
  const axiosConfig: AxiosRequestConfig = {
    url: url,
    method: "POST",
    params: null,
    data: quiz,
    headers: {
      "x-api-key": process.env.REACT_APP_GCP_API_KEY,
      "Content-Type": "application/json",
    },
  };

  const trace = startTrace(perf, `Api call: ${url}`);
  trace.start();

  try {
    const response = await axios(axiosConfig);
    return response;
  } catch (error) {
    throw error;
  } finally {
    trace.stop();
  }
};

export const feedbackConfig = async () => {
  const url = `${process.env.REACT_APP_GCP_BASE_URL}/glamlab/api/hair/v1/feedback-configs`;
  const axiosConfig: AxiosRequestConfig = {
    url: url,
    method: "GET",
    params: null,
    headers: {
      "x-api-key": process.env.REACT_APP_GCP_API_KEY,
      "Content-Type": "application/json",
    },
  };

  const trace = startTrace(perf, `Api call: ${url}`);
  trace.start();

  try {
    const response = await axios(axiosConfig);
    return response;
  } catch (error) {
    throw error;
  } finally {
    trace.stop();
  }
};

export const feedback = async (feedback: any) => {
  const url = `${process.env.REACT_APP_GCP_BASE_URL}/glamlab/api/hair/v1/feedback`;
  const axiosConfig: AxiosRequestConfig = {
    url: url,
    method: "POST",
    params: null,
    data: feedback,
    headers: {
      "x-api-key": process.env.REACT_APP_GCP_API_KEY,
      "Content-Type": "application/json",
    },
  };

  const trace = startTrace(perf, `Api call: ${url}`);
  trace.start();

  try {
    const response = await axios(axiosConfig);
    return response;
  } catch (error) {
    throw error;
  } finally {
    trace.stop();
  }
};
